module.exports = __webpack_public_path__ + "img/about-dots.39139c0d.png";